// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._rTwuDm7q1Il832xRURC{border:1px solid var(--border-neutral-default);background:var(--background-primary-inverted-primary);border-radius:4px;align-items:center;width:-webkit-fit-content;width:fit-content;margin-top:8px;padding:2px 8px;display:flex}._rTwuDm7q1Il832xRURC .Pb8fygmMNoUcoTneoIWx{color:var(--content-primary-primary);font-size:11px;font-weight:400}._rTwuDm7q1Il832xRURC .AhYvN5bgP_QeM6TvPHpU{color:var(--content-primary-tertiary);background-color:transparent;margin-right:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `_rTwuDm7q1Il832xRURC`,
	"name": `Pb8fygmMNoUcoTneoIWx`,
	"icon": `AhYvN5bgP_QeM6TvPHpU`
};
export default ___CSS_LOADER_EXPORT___;
